import { useCallback, useEffect } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { usePopper } from 'react-popper';
export function useAutoClosingPopper(setVisible, referenceElement, popperElement) {
    const hide = useCallback(() => {
        setVisible(false);
    }, [setVisible]);
    const onClickOutsideRef = useOnclickOutside(hide);
    useEffect(() => {
        if (referenceElement) {
            onClickOutsideRef(referenceElement);
        }
        if (popperElement) {
            onClickOutsideRef(popperElement);
        }
    }, [onClickOutsideRef, referenceElement, popperElement]);
}
export function useLitformPopper(popperElement, referenceElement, arrowElement, options) {
    var _a;
    return usePopper(referenceElement, popperElement, Object.assign({ placement: 'bottom', strategy: 'fixed', modifiers: arrowElement
            ? [{ name: 'arrow', options: { element: arrowElement } }, ...((_a = options === null || options === void 0 ? void 0 : options.modifiers) !== null && _a !== void 0 ? _a : [])]
            : options === null || options === void 0 ? void 0 : options.modifiers }, options));
}
export function useLitformPopperWithAutoClosing(popperElement, referenceElement, arrowElement, setVisible, options) {
    useAutoClosingPopper(setVisible, referenceElement, popperElement);
    return useLitformPopper(popperElement, referenceElement, arrowElement, options);
}
export function useToggleOpen(setDropdownOpen, update) {
    const toggleOpen = useCallback(() => {
        setDropdownOpen((prev) => !prev);
        if (update) {
            update();
        }
    }, [update, setDropdownOpen]);
    return toggleOpen;
}
//# sourceMappingURL=PopperUtils.js.map